module.exports = {"baseUrl":"https://uitleendiensterfgoed.borrowme.net/","baseUrl2":"http://localhost:50000/","dev":"https://uitleendiensterfgoed.borrowme.net/","prod":"https://uitleendiensterfgoed.borrowme.net/","test":"https://uitleendiensterfgoed-test.borrowme.net/"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = IuJc
// module chunks = 1